<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s9ILfF/tc-custom/9781626816725.jpg?1702814933340" alt="This image is the cover for the book Texas Dawn, The Texas Star Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Dawn, The Texas Star Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A beautiful blockade runner and the man she loves are reunited at sea—on opposite sides of the Civil War—in this southern historical romance.</b><br/>  <br/><i>Texas, 1863</i>. Stella Duval always hoped to see her beloved Logan Cafferty again, but she never imagined that when the day came, it would be as his captive. Before the Civil War, Stella and Logan had plans to marry. But now they find themselves on opposing sides of a brutal conflict.<br/>  <br/> As a Confederate blockade runner, Stella risks her life to ship supplies from Texas across the Gulf Coast. But when a Union ship takes her prisoner, she is shocked to discover the ship’s Captain is none other than her sweet Logan. Though war has made them enemies, their passion for each other is as strong as ever. Now Stella and Logan must fight to win a second chance at true love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Vaughan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d24ae94